import React, { forwardRef } from 'react'
import emphasizeAmpersand from 'src/helpers/emphasizeAmpersand'

interface IPageTitleProps {
  firstPart: string
  secondPart: string
  thirdPart?: string
  className?: string
  secondPartRed?: boolean
  theme?: 'light' | 'dark'
}

const H2 = forwardRef<HTMLHeadingElement, IPageTitleProps>(
  ({ firstPart, secondPart, thirdPart, className, secondPartRed, theme }, ref) => {
    const textColor = 'text-on-surface'
    const hasThreeParts = Boolean(thirdPart && thirdPart.trim())
    const secondPartColor = hasThreeParts ? textColor : (secondPartRed ? 'text-on-primary-subtle' : textColor)
    const thirdPartColor = secondPartRed ? 'text-on-primary-subtle' : textColor

    return (
      <h2
        ref={ref}
        className={`font-palanquinDark text-display-large md:text-heading-h6 lg:text-heading-h5 xl:text-heading-h3 font-bold ${className}`}
      >
        {firstPart ? (
          <span className={`inline md:block ${textColor}`}>
            {emphasizeAmpersand(firstPart, 1)}{' '}
          </span>
        ) : null}
        {secondPart ? (
          <span className={`inline md:block ${secondPartColor}`}>
            {emphasizeAmpersand(secondPart, 1)}{thirdPart ? ' ' : ''}
          </span>
        ) : null}
        {thirdPart ? (
          <span className={`inline md:block ${thirdPartColor}`}>
            {emphasizeAmpersand(thirdPart, 1)}
          </span>
        ) : null}
      </h2>
    )
  }
)

H2.defaultProps = {
  className: '',
  secondPartRed: true,
  theme: 'light',
}

export default H2
